<div class="header-toolbar">
  <div class="tw-flex tw-justify-between tw-container-lg">
    <div class="tw-flex">
      <img
        class="logo tw-self-center"
        src="assets/core/images/bosch-logo.svg"
        alt="Bosch"
        width="140"
        height="30"
        [class.tw-cursor-pointer]="!noHomePage"
        [routerLink]="noHomePage ? null : '/'"
        (click)="clearSearchedData()"
      />
    </div>
    <div class="tw-flex tw-items-center">
      <bosch-ui-language-select [formControl]="languageControl"></bosch-ui-language-select>
    </div>
  </div>
</div>
